import { defineMessages } from 'react-intl-next';

export default defineMessages({
	sendButtonLabel: {
		id: 'ai-mate.inline-chat-input.send-button.label',
		defaultMessage: 'Submit',
		description:
			"Button label displayed on the submit/send button in the inline chat prompt input area within the AI conversation interface. Shown as the text on a button that users click to send their message or prompt to the AI assistant. The purpose is to clearly indicate the action that will be triggered when the button is clicked, which is to submit the user's input and initiate the AI response.",
	},
	chatInputAssistiveLabel: {
		id: 'ai-mate.inline-chat-input.chat-input-assistive-label',
		defaultMessage: 'Describe what you want to do...',
		description:
			'Accessibility label (aria-label) and placeholder text for the inline chat input text field in the AI conversation interface. Shown as a screen reader announcement when the input field is focused, and as placeholder text visible in the input field when it is empty. The purpose is to guide users on what they should enter in the input field, prompting them to describe the action or task they want the AI assistant to perform. This helps users with assistive technologies understand the input field purpose and provides guidance to all users.',
	},
	chatInputAssistiveLabelShort: {
		id: 'ai-mate.inline-chat-input.chat-input-assistive-label.short',
		defaultMessage: 'Describe what to do...',
		description:
			'Shortened accessibility label and placeholder text for the inline chat input in chromeless/inline comment contexts.',
	},
});
